<template>
    <Layout class="lr-app-layout">
        <Header class="lr-app-header">
            <appHeader />
        </Header>
        <Layout class="lr-app-sub-layout">
            <Sider class="lr-app-sider">
                <sideBar />
            </Sider>
            <Content class="lr-app-content">
                <router-view />
            </Content>
        </Layout>
    </Layout>
</template>
<script>
    import sideBar from './sideBar'
    import appHeader from './header'
    export default {
        components: { sideBar, appHeader }
    }
</script>
<style>
    .lr-app-layout {
        height: 100vh;
        overflow: hidden;
        background: #fff;
    }

    .lr-app-header {
        padding: 0 10px;
        height: 50px;
    }

    .lr-app-sub-layout {
        background: none;
    }

    .lr-app-sider {
        background: #f7ecec;
        overflow: auto;
    }

    .lr-app-sider ul {
        background: none;
    }

    .lr-app-content {
        padding: 5px;
        overflow: auto;
    }

    .ivu-menu-vertical.ivu-menu-light:after {
        background: none;
    }
</style>